export default __webpack_public_path__ + "static/media/burn.779cc363.mp3";